import Swiper from 'swiper';
import { EffectCards, Navigation, Grid } from 'swiper/modules';

const swiperCards = new Swiper('.swiper-conec-cards', {
    slidesPerView: 1,
    modules: [EffectCards, Navigation],
    effect: "cards",
    cardsEffect: {
        rotate: false,
        slideShadows: false,
    },
    navigation: {
        nextEl: '.swiper-cards-button-next',
        prevEl: '.swiper-cards-button-prev',
    },
});

const swiperNames = new Swiper('.swiper-conec-names', {
    slidesPerView: 2,
    loop: false,
    modules: [Navigation, Grid],
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    grid: {
        rows: 4
    },
    on: {
        click: function (swiper, event) {
            swiperCards.slideTo( swiperNames.clickedIndex )
            swiper.slides.forEach( ( slide ) => {
                slide.classList.remove('ativo')
            })
            swiper.slides[swiperNames.clickedIndex].classList.add('ativo')
            document.getElementById('btn-ver-minibio').style.display = 'block';
            const painelistaBios = document.querySelectorAll('.swiper-conec-cards .swiper-slide .bio-wrapper');
            painelistaBios.forEach( ( painelista ) => {
                painelista.classList.add( 'inactive' );
            } );
        }
    }
});



document.addEventListener('DOMContentLoaded', function(){
    const painelistaSlide = document.querySelector( '.swiper-conec-names .swiper-slide' );
    if ( painelistaSlide ) {
        painelistaSlide.classList.add( 'ativo' );

        document.getElementById('btn-ver-minibio').addEventListener('click', ( event ) =>{
            const painelista = document.querySelector('.swiper-conec-cards .swiper-slide-active .bio-wrapper');
            painelista.classList.remove('inactive');
            document.getElementById('btn-ver-minibio').style.display = 'none';
        });

        const btnsClose = document.querySelectorAll( '.btn-close' );
        btnsClose.forEach( ( btnClose ) => {
            btnClose.addEventListener('click', function( event ){
            document.getElementById('btn-ver-minibio').style.display = 'block';
        } )
        });

    }
});